import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function Agitation() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-7">
      <div className="absolute inset-0 bg-red-900/10" data-id="element-8" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border border-red-500/30 p-8 md:p-12 rounded-3xl shadow-[0_0_50px_rgba(239,68,68,0.1)]" data-id="element-10">
          <Flame className="w-16 h-16 text-red-500 mx-auto mb-6" data-id="element-11" />

          <p className="text-xl md:text-3xl leading-relaxed font-medium text-gray-300" data-id="element-12">
            Si tu negocio depende de que{' '}
            <span className="text-white font-bold underline decoration-red-500 decoration-4 underline-offset-4" data-id="element-13">
              TÚ
            </span>{' '}
            respondas cada mensaje, no tienes un negocio; tienes una{' '}
            <span className="text-red-400 font-bold" data-id="element-14">
              "Celda de Castigo Digital"
            </span>
            .
          </p>

          <p className="mt-8 text-lg md:text-xl text-gray-400" data-id="element-15">
            Cada mensaje ignorado es dinero que se lleva tu competencia. Estás a
            un paso del{' '}
            <strong className="text-white" data-id="element-16">burnout (agotamiento total)</strong>.
          </p>
        </motion.div>
      </div>
    </section>;
}